export default __webpack_public_path__ + "static/media/woman-box-5-clear.94b90c8d.svg";